<template>
  <div class="d-board">
    <div class="container settings-section">
      <b-loading-spinner v-if="isLoading" class="txt-center" />
      <div class="mid-area settings-section-box">
        <!-- Response Background with Dynamic Class Binding -->
        <div v-if="responsePresent()" :class="['response-box', responseStatusClass]">
          <span>{{ getResponse() }}</span>
        </div>
        <div v-if="!isLoading" class="settings-section-container page-container">
          <div class="page-text">
            <span>Copy the Pixels to the Advertisers file in the Pixel Connector bucket</span>
          </div>
          <div>
            <k-button
              class="button-div"
              :size="4"
              label="Copy To Bucket"
              @click="dumpDRPixelsToBucket()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flipPixelsFileApi from '@/api/flipPixelsFileApi';

export default {
  name: 'SettingsSection',
  data() {
    return {
      isLoading: false,
      theResponse: null,
      responseStatus: '', // New attribute to track response status (success or failure)
    };
  },
  computed: {
    responseStatusClass() {
      if (this.responseStatus === 'success') {
        return 'success-background';
      }
      return this.responseStatus === 'failure' ? 'failure-background' : '';
    },
  },
  async mounted() {
    console.log('SettingsSection mounted');
  },
  methods: {
    async dumpDRPixelsToBucket() {
      try {
        const response = await flipPixelsFileApi.dumpToBucket();
        this.theResponse = `Data copied to the bucket: ${response.message || 'Successful!'}`;
        this.responseStatus = 'success'; // Mark as success
        this.clearTheResponse();
      } catch (e) {
        this.theResponse = `Request to copy failed: ${e.message || e}`;
        this.responseStatus = 'failure'; // Mark as failure
        this.clearTheResponse();
      }
    },
    clearTheResponse() {
      setTimeout(() => {
        this.theResponse = null;
        this.responseStatus = ''; // Clear status after timeout
      }, 5000);
    },
    responsePresent() {
      return this.theResponse && this.theResponse.trim() !== '';
    },
    getResponse() {
      return this.theResponse;
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-section {
  padding-top: 0px !important;
  position: relative;
}

.page-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 20px 10px;
}

.settings-section-box {
  top: 13px;
  position: relative;
  z-index: 2;
  color: #fff;
  background-color: #212429;
  border-radius: 0;
  padding: 30px 20px;
  width: 100%;
  display: block;
  min-width: 900px;
  max-width: 900px;
  min-height: 500px;
  margin: 0 auto;
}

.txt-center {
  position: absolute !important;
  margin-top: 15px;
  font-size: 13px;
  color: #bac0c5;
  text-align: center !important;
  top: 200px;
  margin: 0px auto;
  z-index: 10;
  width: 100%;
}

.button-div {
  align: right;
}

.page-text {
  font-size: 13px;
  font-weight: 600;
  padding: 10px 10px 20px 10px;
  width: 100%;
  text-align: left;
  color: #fff;
}

/* Success and Failure Backgrounds */
.response-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 20px 10px;
  border-radius: 5px;
  width: 100%;
  font-weight: bold;
  text-align: center;
}

.success-background {
  background-color: #c1e1c1; /* Light pastel green */
  color: green;
}

.failure-background {
  background-color: #f8d7da; /* Light pastel red */
  color: red;
}
</style>
